export type InboxReducerState = {
  filters: InboxFilters;
  data?: InboxData | null;
};

export type InboxFilters = {
  order: 'asc' | 'desc';
  orderBy: InboxOrderBy;
  query: string;
};

export type InboxOrderBy = 'vendor' | 'date' | 'amount' | 'status';
export type InboxControlFilter = 'freeText';

export type InboxData = {
  inboxes: InboxItem[];
};

export type InboxItem = {
  id: string;
  title?: string;
  status: InboxStatus;
  source: {
    type: 'GMAIL';
    img: string;
  };
  address: string;
  creation_date: string;
  last_sync_date: string;
  receipts_count: number;
  tags: string[];
};

export enum InboxStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}
